export default __webpack_public_path__ + "static/media/nftMob.e4b14a25.png";